import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import PageTransition from '../components/common/PageTransition';
import SEO from '../components/common/SEO';

const NotFound = () => {
  return (
    <PageTransition>
      <SEO
        title="Page Not Found - 404"
        description="The page you are looking for does not exist on The Tiny Times website."
        noIndex={true}
      />
      <div className="min-h-screen flex items-center justify-center overflow-hidden"
        style={{ background: 'linear-gradient(160deg, #EDF7EE 0%, #EFF6FF 45%, #F3EEFF 100%)' }}>

        {/* Subtle grid */}
        <div className="absolute inset-0 opacity-20 pointer-events-none"
          style={{ backgroundImage: 'radial-gradient(circle, rgba(123,47,190,0.12) 1px, transparent 1px)', backgroundSize: '36px 36px' }} />

        {/* Floating emojis */}
        {[{ e: '🌈', x: '7%', y: '18%' }, { e: '⭐', x: '88%', y: '15%' }, { e: '🚀', x: '82%', y: '75%' }, { e: '🎨', x: '5%', y: '78%' }].map((item, i) => (
          <motion.div key={i} className="absolute text-5xl opacity-25 pointer-events-none select-none"
            style={{ left: item.x, top: item.y }}
            animate={{ y: [0, -20, 0], rotate: [0, 15, -15, 0] }}
            transition={{ duration: 4 + i * 0.5, repeat: Infinity, delay: i * 0.4 }}>
            {item.e}
          </motion.div>
        ))}

        <div className="container mx-auto px-4 relative z-10">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
            className="max-w-2xl mx-auto text-center">

            {/* Animated emoji */}
            <motion.div
              animate={{ rotate: [0, 10, -10, 10, 0], scale: [1, 1.1, 1] }}
              transition={{ duration: 2, repeat: Infinity, repeatDelay: 1 }}
              className="text-9xl mb-6">😵</motion.div>

            {/* 404 */}
            <h1 className="text-7xl md:text-9xl font-display font-bold mb-3"
              style={{ background: 'linear-gradient(135deg, #7B2FBE, #1565C0)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
              404
            </h1>

            <h2 className="text-3xl md:text-4xl font-display font-bold mb-5" style={{ color: '#1A1F2E' }}>
              Oops! Page Not Found
            </h2>

            <p className="text-xl text-neutral-gray-dark mb-10 max-w-lg mx-auto">
              Looks like this page went on an adventure and got lost! Don't worry, we'll help you find your way back. 🗺️
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <motion.div whileHover={{ scale: 1.05, y: -3 }} whileTap={{ scale: 0.97 }}>
                <Link to="/"
                  className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-button font-display font-bold text-xl text-white"
                  style={{ background: 'linear-gradient(135deg, #3CB044, #1E7C24)', boxShadow: '0 6px 24px rgba(60,176,68,0.3)' }}>
                  🏠 Go Home
                </Link>
              </motion.div>
              <motion.div whileHover={{ scale: 1.05, y: -3 }} whileTap={{ scale: 0.97 }}>
                <Link to="/contact"
                  className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-button font-display font-bold text-xl"
                  style={{ background: 'white', color: '#7B2FBE', border: '2px solid rgba(123,47,190,0.25)', boxShadow: '0 4px 16px rgba(123,47,190,0.1)' }}>
                  📧 Contact Us
                </Link>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </PageTransition>
  );
};

export default NotFound;